let inMemoryToken: string | null = null;

export const HM_TOKEN = "hm_token";
export const HM_TOKEN_MARKER = "hm_token_marker";

export function getCookieDomain(): string | undefined {
  if (window.location.hostname === "localhost") return undefined;
  return `.${window.location.hostname.split(".").slice(-2).join(".")}`;
}

export function getCookie(name: string): string | null {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookieValue = parts.pop()?.split(";").shift();
    return cookieValue || null;
  }
  return null;
}

export function setCookie(name: string, value: string, expires: Date): void {
  const domain = getCookieDomain();
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Lax${domain ? `; domain=${domain}` : ""}`;
}

export function removeCookie(name: string): void {
  const domain = getCookieDomain();
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax${domain ? `; domain=${domain}` : ""}`;
}

export function setAuthToken(token: string): void {
  inMemoryToken = token;
  try {
    localStorage.setItem(HM_TOKEN, token);
    // set cookie so we will be automatically logged in on healthmatch.io
    setCookie(
      HM_TOKEN,
      token,
      new Date(Date.now() + 90 * 60 * 1000), // 90 minutes
    );
    // Set tracking cookie to remember user was authenticated
    setHadAuthBefore();
    if (import.meta.env.DEV) {
      // Expose for quick inspection in dev tools without logging the full token
      // @ts-ignore
      window.__MM_AUTH_TOKEN_PRESENT__ = true;
    }
  } catch {}
}

export function getAuthToken(): string | null {
  if (inMemoryToken) return inMemoryToken;
  try {
    const stored = localStorage.getItem(HM_TOKEN);
    inMemoryToken = stored;
    return stored;
  } catch {
    return null;
  }
}

export function clearAuthToken(): void {
  inMemoryToken = null;
  try {
    localStorage.removeItem(HM_TOKEN);
    // Remove cookie
    removeCookie(HM_TOKEN);
    if (import.meta.env.DEV) {
      // @ts-ignore
      window.__MM_AUTH_TOKEN_PRESENT__ = false;
    }
  } catch {}
}

export function setHadAuthBefore(): void {
  setCookie(
    HM_TOKEN_MARKER,
    "true",
    new Date(Date.now() + 400 * 24 * 60 * 60 * 1000), // 400 days - max expiry supported by chrome
  );
}

export function getHadAuthBefore(): boolean {
  return getCookie(HM_TOKEN_MARKER) !== "false";
}

export function removeHadAuthBefore(): void {
  setCookie(
    HM_TOKEN_MARKER,
    "false",
    new Date(Date.now() + 400 * 24 * 60 * 60 * 1000),
  );
}
